export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || '404780459154-t8gil5r6tu0m7uee584nl47obf7rshel.apps.googleusercontent.com';
